import { useQuery } from "@tanstack/react-query";
import { fetchAddressSuggestions } from "@/sales-tools/home-product/api/addressSuggestions";

export const useAddressSearch = (searchText: string, isEnabled = true) => {
    return useQuery({
        queryKey: ["address-lookup", searchText],
        queryFn: async () => fetchAddressSuggestions(searchText),
        retry: false,
        enabled: isEnabled,
    });
};
